import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';

const LoadingSpinner = ({ size = '50px', message = 'Loading...' }) => {
  return (
    <div className="min-h-screen flex align-items-center justify-content-center surface-ground">
      <div className="text-center">
        <ProgressSpinner 
          style={{ width: size, height: size }} 
          strokeWidth="4"
          fill="var(--surface-ground)"
          animationDuration=".5s"
        />
        {message && (
          <p className="mt-3 text-color-secondary">{message}</p>
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner;